module.exports = __webpack_public_path__ + "static/media/simple-line-icons_home.c758e745.png";